import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Zutaten", -1)
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", null, "Hinzuf.", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("em", null, "Keine Zutaten", -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.newIngredientEvent && _ctx.newIngredientEvent(...args)), ["prevent"]))
    }, [
      _createElementVNode("p", null, [
        _createElementVNode("label", null, [
          _createTextVNode(" Name: "),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newIngredient.name) = $event)),
            id: "new-ingredient-name",
            placeholder: 'Zutat ' + (_ctx.ingredients.length+1)
          }, null, 8, _hoisted_2), [
            [
              _vModelText,
              _ctx.newIngredient.name,
              void 0,
              { trim: true }
            ]
          ])
        ])
      ]),
      _createElementVNode("p", null, [
        _createElementVNode("label", null, [
          _createTextVNode(" Brennwert (kcal/100g): "),
          _withDirectives(_createElementVNode("input", {
            type: "number",
            min: "0",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newIngredient.caloriesPerHundredGrams) = $event))
          }, null, 512), [
            [
              _vModelText,
              _ctx.newIngredient.caloriesPerHundredGrams,
              void 0,
              { number: true }
            ]
          ])
        ])
      ]),
      _createElementVNode("p", null, [
        _createElementVNode("label", null, [
          _createTextVNode(" Menge (g): "),
          _withDirectives(_createElementVNode("input", {
            type: "number",
            min: "1",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newIngredient.amountInGrams) = $event))
          }, null, 512), [
            [
              _vModelText,
              _ctx.newIngredient.amountInGrams,
              void 0,
              { number: true }
            ]
          ])
        ])
      ]),
      _hoisted_3
    ], 32),
    (_ctx.ingredients.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ingredients, (ingredient, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: ingredient.name
            }, [
              _createTextVNode(_toDisplayString(ingredient.name) + ", " + _toDisplayString(ingredient.caloriesPerHundredGrams) + "kcal/100g, " + _toDisplayString(ingredient.amountInGrams) + "g ", 1),
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.$emit('removeIngredient', index))
              }, "Entfernen", 8, _hoisted_5)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_6, _hoisted_8))
  ], 64))
}